import React from 'react'

export const Input = ({className,label,name,value,info,error,onChange,type,autoComplete}) => {

  return (
    <div className={`form-group ${className}`}>
        <label>{label}</label>
        <input autoComplete={autoComplete} type={type} value={value} name={name} onChange={onChange} className="form-control" />
        {error && <div className='alert alert-danger'>{error}</div>}
        {info && <small>{info}</small>}
    </div>
  )
}
